import React from 'react';
import { Helmet } from "react-helmet";
import CarouselGolden from './CarouselGolden';
import { Tabs, Tab, Row, Col } from 'react-bootstrap';
import VideoList from './VideoList';
import './Births.css';

import scapa_1 from './video/scapa_5.mp4';
import scapa_2 from './video/scapa_6.mp4';
import scapa_3 from './video/scapa_7.mp4';

const images = require.context('./img/golden/naissance/naissance_old', true);
const imageList = images.keys().map(image => images(image));

const images_scapa = require.context('./img/golden/naissance/naissance_scapa/current', true);
const imageList2 = images_scapa.keys().map(image => images_scapa(image));
const videos_scapa = [scapa_1, scapa_2, scapa_3]

const Births = () => {
  return (
    <div className="container">
      <Helmet>
        <title>Dernières naissances de chiots golden retriever</title>
        <meta
          name="description"
          content="Retrouvez l'actualité des dernières naissances de chiots golden retriever de travail dans le Puy-de-dôme de l'élevage au travers de photos et de vidéos."
        />
      </Helmet>
      <h1 className='mb-3'>Carnet de naissances</h1>
      <Tabs>
        <Tab eventKey="Scapa" title="Scapa">
          <Row>
            <Col>
              <Row>
                <p className='mt-3 mb-3'>
                  Les chiots de Scapa et Tommy sont arrivés ce début février.
                </p>
              </Row>
            <Row>
                <VideoList videos={videos_scapa} nom="Scapa"/>
              </Row>
            </Col>
            <Col>
              <div className='d-flex justify-content-center'>
                <CarouselGolden imageList={imageList2} />
              </div>
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="Speyburn" title="Speyburn">
          <Row>
            <Col>
              <Row>
                <p className='mt-3 mb-3'>
                  Les chiots de Speyburn et Tommy sont prévus pour fin avril.
                </p>
              </Row>
            </Col>
          </Row>
            {/*<Row>
                <VideoList videos={videos_scapa} nom="Scapa"/>
              </Row>
            </Col>
            <Col>
              <div className='d-flex justify-content-center'>
                <CarouselGolden imageList={imageList2} />
              </div>
            </Col>
          </Row>*/}
        </Tab>
        <Tab eventKey="Usher" title="Usher">
          <Row>
            <Col>
              <Row>
                <p className='mt-3 mb-3'>
                  Les chiots de Usher et Tommy sont prévus pour début mai.
                </p>
              </Row>
            </Col>
          </Row>
            {/*<Row>
                <VideoList videos={videos_scapa} nom="Scapa"/>
              </Row>
            </Col>
            <Col>
              <div className='d-flex justify-content-center'>
                <CarouselGolden imageList={imageList2} />
              </div>
            </Col>
          </Row>*/}
        </Tab>
      </Tabs>
      <div className='d-flex justify-content-center h-100 w-100 sep'>
        <CarouselGolden imageList={imageList} cN='w-50'/>
      </div>
      <p className='d-flex justify-content-center mt-3'>
        Photos des anciennes portées.
      </p>
    </div>
  );
};

export default Births;
